import React from 'react';
import {
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Menu,
  MenuButton,
  Radio,
  RadioGroup,
  useDisclosure,
  VStack,
  chakra,
  Button,
  Image,
  HStack,
  Text,
} from '@chakra-ui/react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/form-control';
import { useField } from 'formik';
import { ChevronDownIcon } from '@chakra-ui/icons';
import empresa from 'images/dashboard/empresa.svg';

const SelectField = ({ label, ...props }) => {
  const { options, placeholder, onChange, image } = props;
  const [field, meta, helpers] = useField(props);
  const { value } = meta;

  const { setValue } = helpers;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const colorErro = meta.error ? { colorScheme: 'red' } : {};
  let textButton;
  if (typeof value === 'number') {
    if (typeof options[value] === 'string') {
      textButton = options[value].substring(0, 25) + (options[value].length > 25 ? '...' : '');
    } else {
      textButton = '';
    }
  } else if (placeholder) {
    textButton = placeholder;
  } else {
    textButton = 'Selecionar';
  }

  return (
    <>
      <FormControl isInvalid={meta.error}>
        <FormLabel>{label}</FormLabel>
        <Menu>
          <Center>
            <MenuButton as={Button} onClick={onOpen} rightIcon={<ChevronDownIcon />} {...field} {...props} {...colorErro}>
              <HStack spacing={0} justify="center">
                {image && <Image src={image} boxSize="20px" mr="16px" />}
                <Text fontWeight="bold" color="#757575">
                  {textButton}
                </Text>
              </HStack>
            </MenuButton>
          </Center>
        </Menu>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </FormControl>
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent borderRadius={20} mb="0" w="100%" maxW="500px" mx="auto" maxH="calc(100dvh - 88px)" display="flex">
          <DrawerHeader mt="5" flexShrink={0}>
            Selecione
          </DrawerHeader>

          <DrawerBody overflowY="auto" minH={0} pb="calc(env(safe-area-inset-bottom) + 96px)" WebkitOverflowScrolling="touch">
            <RadioGroup
              name="select"
              w="100%"
              value={value}
              pb={5}
              onChange={(e) => {
                setValue(parseInt(e));
                onChange(e);
                onClose();
              }}
            >
              <VStack align="start" w="100%" spacing={1}>
                {options.map((option, index) => {
                  return (
                    <Radio id={index} value={index} padding="1em">
                      <chakra.p fontWeight="bold" fontSize="sm">
                        <Text color="#757575">{option}</Text>
                      </chakra.p>
                    </Radio>
                  );
                })}
              </VStack>
            </RadioGroup>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SelectField;
